export default[
    {
        path: '/collectMoney/paperCard',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '纸质划卡',
            keepAlive: false
        }
    },
    
]